export const FidelityCustomerFieldEnum = {
  Mandatory: "MANDATORY",
  Optional: "OPTIONAL",
  Hidden: "HIDDEN",
};

export type FidelityCustomerFieldEnum =
  (typeof FidelityCustomerFieldEnum)[keyof typeof FidelityCustomerFieldEnum];
